const axios = require("axios");
const config = require("./config.js");

module.exports = {
  check_token: (token) => { // 가지고 있는 토큰 체크
    return new Promise((resolv) => {
      axios({
        url: config.apiurl + '/user/check_token',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        data: {
          token: token
        }
      }).then((response) => {
        resolv(response.data.result);
      }).catch(function (error) {
        alert('오류가 발생했습니다...(1)');
        console.log(error);
      })
    });
  },
  logout: (token) => { // 로그아웃
    return new Promise((resolv) => {
      axios({
        url: config.apiurl + '/user/logout',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        data: {
          token: token
        }
      }).then((response) => {
        let d = response.data;
        // console.log(d);
        if (d.result == 1) {
          alert("로그아웃되었습니다.");
          resolv(true);
        } else {
          alert("로그아웃에 실패했습니다.");
          resolv(false);
        }
      }).catch(function (error) {
        alert('오류가 발생했습니다...(2)');
        console.log(error);
      })
    })
  },
  remained_time: (expireddate) => { // 잔여시간 계산
    let a = new Date(expireddate);
    let b = new Date();

    let base = (a - b) / 1000;

    let hour = Math.floor(base / 60 / 60);
    let minute = Math.floor(base / 60 % 60);
    let second = Math.floor(base % 60);

    if (hour > 0 && hour < 10) { hour = '0' + hour.toString(); } else if (hour == 0) { hour = '00'; }
    if (minute > 0 && minute < 10) { minute = '0' + minute.toString(); } else if (minute == 0) { minute = '00'; }
    if (second > 0 && second < 10) { second = '0' + second.toString(); } else if (second == 0) { second = '00'; }

    let timestr = "";
    if (base >= 0) { timestr = hour + ":" + minute + ":" + second; }
    else { timestr = '00:00:00'; }

    return timestr;
  },
  // check_perm(token, page_perm) {
  //   return new Promise((resolv) => {
  //     var url = 'https://cjm.cloud.olym.co.kr/api/index.php?part=util&mode=check_perm';
  //     axios({
  //       url: url,
  //       headers: {
  //         'Access-Control-Allow-Origin': '*',
  //         'Content-Type': 'application/json',
  //       },
  //       method: 'POST',
  //       data: {
  //         token: token,
  //         page_perm: page_perm,
  //       }
  //     }).then((response) => {
  //       // console.log(response.data);
  //       if (response.data.result == -1) {
  //         alert("페이지 접근 권한이 없습니다.");
  //         location.href = '/mypage';
  //       }

  //       resolv();
  //     }).catch(function (error) {
  //       alert('오류가 발생했습니다...(3)');
  //       console.log(error);
  //     })
  //   })
  // },
  get_info(token) {
    return new Promise((resolv) => {
      axios({
        url: config.apiurl + '/user/get_userinfo',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        data: {
          token: token,
        }
      }).then((response) => {
        let d = response.data;
        // console.log(d);
        resolv(d.user_info);
      }).catch(function (error) {
        alert('오류가 발생했습니다...(4)');
        console.log(error);
      })
    });
  },
  set_page_option(that, page_option) {
    page_option.name = that.$route.name;
    that.$store.commit('set_page', page_option);
  },
  reset_page_option(that) { // vuex store에 저장된 페이징 및 검색기록 초기화
    that.$store.commit('set_page', {
      name: "",
      page: 0,
      page_total: 1,
      search: "",
      limit: 10,
      total_count: 0,
    });
  },
  set_page(that) { // 페이지 세팅
    return new Promise((resolv) => {
      let page_option = that.$store.state.page_option;
      if (page_option.name == that.$route.name) {
        that.page_option = page_option;
      }
      resolv(1);
    });
  },
  isMobile() {
    return new Promise((resolv) => {
      var user = navigator.userAgent;
      var is_mobile = false;

      if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
        is_mobile = true;
      }
      resolv(is_mobile);
    })
  },
  numbering(num) {
    return num + 1;
  },
  getPrice: (price) => {
    price = parseInt(price);
    let price_p = Math.floor(price / 1000000); // 플래티넘
    price %= 1000000;

    let price_g = Math.floor(price / 10000); // 골드
    price %= 10000;

    let price_s = Math.floor(price / 100); // 실버
    price %= 100;

    let price_c = price; // 동

    let result = [];
    if (price_p > 0) result.push(`${price_p}플`);
    if (price_g > 0) result.push(`${price_g}골`);
    if (price_s > 0) result.push(`${price_s}실`);
    if (price_c > 0) result.push(`${price_c}동`);

    // 값이 전부 0일 때도 표시
    if (result.length === 0) result.push("0동");

    let result_all = result.join(" ");

    result_all = result_all.replace("플", ` <img alt="coin_platinum" src="/images/coin_platinum.png"> `);
    result_all = result_all.replace("골", ` <img alt="coin_gold" src="/images/coin_gold.png"> `);
    result_all = result_all.replace("실", ` <img alt="coin_silver" src="/images/coin_silver.png"> `);
    result_all = result_all.replace("동", ` <img alt="coin_copper" src="/images/coin_copper.png"> `);

    return result_all;
  }
}